import OpenInnovationPage from './OpenInnovationPage';
export default OpenInnovationPage;
